import { theme } from 'css/utils';
import styled from 'styled-components';
import MiniSpinner from './MiniSpinner';
import { Spinner } from 'reactstrap';

const FetchLoaderStyles = styled.div`
  background: ${props => (props.inlineLoader ? 'none' : `${theme.pageBackground}`)};
  border-radius: 50%;
  display: flex;
  width: ${props => (props.inlineLoader ? 'auto' : `33px`)};
  height: ${props => (props.inlineLoader ? 'auto' : `33px`)};
  min-height: 23px;
  box-shadow: ${props => (props.inlineLoader ? 'none' : `var(--modal-box-shadow)`)};
  align-items: center;
  justify-content: center;
  position: ${props => (props.inlineLoader ? 'relative' : `absolute`)};
  z-index: 99;
  left: 50%;
  transform: translate(-50%, 0);
`;

const ButtonLoaderStyles = styled.div`
  ${FetchLoaderStyles};
  .spinner-border {
    width: 14px !important;
    height: 14px !important;
  }
  min-height: 14px;
`;

export const LoadingSpinner = () => {
  return <MiniSpinner centerAligned={true} />;
};

interface FetchingSpinnerProps {
  inlineLoader?: boolean;
}

export const FetchingSpinner = ({ inlineLoader }: FetchingSpinnerProps) => {
  return (
    <FetchLoaderStyles inlineLoader={inlineLoader}>
      <Spinner size='sm' />
    </FetchLoaderStyles>
  );
};

interface ButtonSpinnerProps {
  inlineLoader?: boolean;
}

export const ButtonSpinner = ({ inlineLoader = true }: ButtonSpinnerProps) => {
  return (
    <ButtonLoaderStyles inlineLoader={inlineLoader}>
      <Spinner size='sm' />
    </ButtonLoaderStyles>
  );
};
